import { useNavigate, useSearchParams } from "react-router-dom";
import { copy } from "@wheels-crm/shared-types";
import type { ProductLine } from "@wheels-crm/shared-types";
import { normalizePhone } from "../lib/phone";
import { supabase } from "../lib/supabaseClient";
import { OrderForm, emptyOrderFormValues, type OrderFormValues } from "../components/orders/OrderForm";

export function NewOrderPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const productLine: ProductLine =
    searchParams.get("line") === "steering_wheels" ? "steering_wheels" : "wheels";

  async function handleSubmit(values: OrderFormValues) {
    const phone = normalizePhone(values.phone);

    // Диски and рулі keep fully separate client lists (owner's explicit choice) — the same
    // phone number can be a distinct client per product line.
    const { data: existingClient } = await supabase
      .from("clients")
      .select("id")
      .eq("phone", phone)
      .eq("product_line", productLine)
      .maybeSingle();

    let clientId = existingClient?.id;
    if (!clientId) {
      const { data: newClient, error: clientError } = await supabase
        .from("clients")
        .insert({ name: values.clientName, phone, product_line: productLine })
        .select("id")
        .single();
      if (clientError) throw clientError;
      clientId = newClient.id;
    }

    const {
      data: { user },
    } = await supabase.auth.getUser();

    const { data: order, error: orderError } = await supabase
      .from("orders")
      .insert({
        client_id: clientId,
        product_line: productLine,
        size_spec: productLine === "wheels" ? values.sizeSpec : null,
        car_brand: values.carBrand || null,
        car_year: values.carYear ? Number(values.carYear) : null,
        source: values.source,
        purchase_price: values.purchasePrice ? Number(values.purchasePrice) : null,
        amount: values.amount ? Number(values.amount) : null,
        prepayment: values.prepayment ? Number(values.prepayment) : null,
        extra_sales: values.extraSales ? Number(values.extraSales) : null,
        delivery_cost: values.deliveryCost ? Number(values.deliveryCost) : null,
        order_comment: values.orderComment || null,
        notes: values.notes || null,
        created_by: user?.id,
      })
      .select("id")
      .single();
    if (orderError) throw orderError;

    await supabase.from("order_events").insert({
      order_id: order.id,
      actor: user?.id,
      event_type: "created",
      payload: {},
    });

    navigate(`/orders/${order.id}`);
  }

  return (
    <div>
      <div className="page-header">
        <h1>
          {copy.newOrderButton} — {copy.productLine[productLine]}
        </h1>
      </div>
      <OrderForm
        initial={emptyOrderFormValues()}
        submitLabel={copy.save}
        onSubmit={handleSubmit}
        onCancel={() => navigate(-1)}
        productLine={productLine}
      />
    </div>
  );
}
